import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-types-papi';

export const FETCH_LATEST_DEVIATIONS_SUCCESS =
  'FETCH_LATEST_DEVIATIONS_SUCCESS';
export const FETCH_MORE_LATEST_DEVIATIONS = 'FETCH_MORE_LATEST_DEVIATIONS';
export const FETCH_FEATURED_DEVIATIONS_SUCCESS =
  'FETCH_FEATURED_DEVIATIONS_SUCCESS';

export type UpdateCoverDeviationPayload = {
  deviation: PapiDeviation;
  version: number;
};
export const updateCoverDeviation = createAction<UpdateCoverDeviationPayload>(
  'UPDATE_COVER_DEVIATION'
);

export type UpdateCoverDeviationOffsetYPayload = {
  offsetY: number;
  version: number;
};
export const updateCoverDeviationOffsetY = createAction<
  UpdateCoverDeviationOffsetYPayload
>('UPDATE_COVER_DEVIATION_OFFSET_Y');

export const deleteCoverDeviation = createAction('DELETE_COVER_DEVIATION');

// TODO use redux-actions for all actions
export const fetchLatestDeviationsSuccess = (
  normalizedData: Record<string, any>
) => ({
  type: FETCH_LATEST_DEVIATIONS_SUCCESS,
  ...normalizedData,
});

export const fetchFeaturedDeviationsSuccess = (
  normalizedData: Record<string, any>
) => ({
  type: FETCH_FEATURED_DEVIATIONS_SUCCESS,
  ...normalizedData,
});
